"use strict";

if (!window.__marketingAttributionInit) {
  window.__marketingAttributionInit = true;

  (function () {
    const COOKIE_NAME = "ans_attribution";
    const MAX_AGE_DAYS = 30;
    const PAID_MEDIUMS = new Set([
      "cpc",
      "ppc",
      "paid",
      "paid_social",
      "paidsocial",
      "display",
      "cpm",
      "retargeting",
      "paid-social",
    ]);
    const SEARCH_ENGINE_HOSTS = [
      "google.",
      "bing.",
      "yahoo.",
      "duckduckgo.",
      "baidu.",
      "yandex.",
      "ecosia.",
      "ask.com",
    ];

    const TYPE_LABELS = {
      paid: "付费广告",
      organic: "自然搜索",
      direct: "直接访问",
      referral: "外链推荐",
    };
    const SOURCE_LABELS = {
      facebook: "来源-Facebook",
      google: "来源-Google",
      tiktok: "来源-TikTok",
      bing: "来源-Bing",
      yahoo: "来源-Yahoo",
      duckduckgo: "来源-DuckDuckGo",
      baidu: "来源-百度",
      search: "来源-搜索",
    };

    function sanitizeTagKey(value) {
      return String(value || "")
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .slice(0, 48);
    }

    function sanitizeChineseTag(value) {
      return String(value || "")
        .trim()
        .replace(/[,，]/g, "")
        .slice(0, 40);
    }

    function readCookie(name) {
      const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));

      return match ? decodeURIComponent(match[1]) : "";
    }

    function writeCookie(name, value, days) {
      const maxAge = Math.max(1, days) * 24 * 60 * 60;
      document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
    }

    function getHostname(url) {
      try {
        return new URL(url).hostname.toLowerCase();
      } catch {
        return "";
      }
    }

    function isSameSiteReferrer(referrer) {
      if (!referrer) {
        return false;
      }

      return getHostname(referrer) === window.location.hostname.toLowerCase();
    }

    function isOrganicSearchReferrer(referrer) {
      const host = getHostname(referrer);

      if (!host) {
        return false;
      }

      return SEARCH_ENGINE_HOSTS.some((needle) => host.includes(needle));
    }

    function sourceFromSearchReferrer(referrer) {
      const host = getHostname(referrer);

      if (host.includes("google.")) {
        return "google";
      }

      if (host.includes("bing.")) {
        return "bing";
      }

      if (host.includes("yahoo.")) {
        return "yahoo";
      }

      if (host.includes("duckduckgo.")) {
        return "duckduckgo";
      }

      if (host.includes("baidu.")) {
        return "baidu";
      }

      return "search";
    }

    function detectFromUrl(searchParams) {
      const utmSource = sanitizeTagKey(searchParams.get("utm_source"));
      const utmMedium = sanitizeTagKey(searchParams.get("utm_medium"));
      const utmCampaign = sanitizeChineseTag(searchParams.get("utm_campaign"));

      if (searchParams.get("fbclid")) {
        return {
          type: "paid",
          src: utmSource || "facebook",
          med: utmMedium || "paid",
          camp: utmCampaign,
        };
      }

      if (searchParams.get("gclid")) {
        return {
          type: "paid",
          src: utmSource || "google",
          med: utmMedium || "cpc",
          camp: utmCampaign,
        };
      }

      if (searchParams.get("ttclid")) {
        return {
          type: "paid",
          src: utmSource || "tiktok",
          med: utmMedium || "paid",
          camp: utmCampaign,
        };
      }

      if (searchParams.get("msclkid")) {
        return {
          type: "paid",
          src: utmSource || "bing",
          med: utmMedium || "cpc",
          camp: utmCampaign,
        };
      }

      if (utmSource && utmMedium && PAID_MEDIUMS.has(utmMedium)) {
        return {
          type: "paid",
          src: utmSource,
          med: utmMedium,
          camp: utmCampaign,
        };
      }

      if (utmSource || utmMedium || utmCampaign) {
        return {
          type: utmMedium === "organic" ? "organic" : "referral",
          src: utmSource || "",
          med: utmMedium,
          camp: utmCampaign,
        };
      }

      return null;
    }

    function detectFromReferrer(referrer) {
      if (!referrer || isSameSiteReferrer(referrer)) {
        return {
          type: "direct",
          src: "",
          med: "",
          camp: "",
        };
      }

      if (isOrganicSearchReferrer(referrer)) {
        return {
          type: "organic",
          src: sourceFromSearchReferrer(referrer),
          med: "organic",
          camp: "",
        };
      }

      return {
        type: "referral",
        src: sanitizeTagKey(getHostname(referrer).replace(/\./g, "-")),
        med: "referral",
        camp: "",
      };
    }

    function captureAttribution() {
      if (readCookie(COOKIE_NAME)) {
        return;
      }

      const searchParams = new URLSearchParams(window.location.search);
      const fromUrl = detectFromUrl(searchParams);
      const referrer = document.referrer || "";
      const data = fromUrl || detectFromReferrer(referrer);

      writeCookie(
        COOKIE_NAME,
        JSON.stringify({
          type: data.type || "direct",
          src: data.src || "",
          med: data.med || "",
          camp: data.camp || "",
          ts: Date.now(),
        }),
        MAX_AGE_DAYS,
      );
    }

    function readAttribution() {
      const raw = readCookie(COOKIE_NAME);

      if (!raw) {
        return null;
      }

      try {
        return JSON.parse(raw);
      } catch {
        return null;
      }
    }

    function formatTypeTag(type) {
      return TYPE_LABELS[type] || "";
    }

    function formatSourceTag(src) {
      const key = sanitizeTagKey(src);

      if (SOURCE_LABELS[key]) {
        return SOURCE_LABELS[key];
      }

      if (!src) {
        return "";
      }

      if (/^[a-z0-9-]+$/.test(key) && key.includes("-")) {
        return `来源-${sanitizeChineseTag(key.replace(/-/g, "."))}`;
      }

      return `来源-${sanitizeChineseTag(src)}`;
    }

    function formatCampaignTag(campaign) {
      const camp = sanitizeChineseTag(campaign);

      return camp ? `活动-${camp}` : "";
    }

    window.getMarketingAttributionTags = function getMarketingAttributionTags() {
      const data = readAttribution();

      if (!data) {
        return [];
      }

      const tags = [];
      const typeTag = formatTypeTag(data.type);

      if (typeTag) {
        tags.push(typeTag);
      }

      const sourceTag = formatSourceTag(data.src);

      if (sourceTag) {
        tags.push(sourceTag);
      }

      const campaignTag = formatCampaignTag(data.camp);

      if (campaignTag) {
        tags.push(campaignTag);
      }

      return tags;
    };

    window.appendMarketingAttributionTags = function appendMarketingAttributionTags(form, extraTags) {
      const tagsField = form?.querySelector('[name="contact[tags]"]');

      if (!tagsField) {
        return;
      }

      const existing = tagsField.value
        .split(",")
        .map((tag) => tag.trim())
        .filter(Boolean);
      const attributionTags = window.getMarketingAttributionTags?.() || [];
      const additional = Array.isArray(extraTags) ? extraTags : [];
      const merged = [];

      for (const tag of [...existing, ...attributionTags, ...additional]) {
        const normalized = String(tag || "").trim();

        if (normalized && !merged.includes(normalized)) {
          merged.push(normalized);
        }
      }

      tagsField.value = merged.join(",");
    };

    captureAttribution();
  })();
}
